/* eslint-disable import-x/order -- polyfills must load before app/external imports */
import 'urlpattern-polyfill'; // conditionally loading does not work
import 'url-search-params-polyfill';
import 'whatwg-fetch'; // fetch polyfill

import { Suspense } from 'react';

import { getFeatureFlags, InitializeFeatureFlags } from '@platform/ui-config';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import Constants from './Auxillary/constants';
import Env from './Auxillary/environment-variables';
import { i18nDebugLog } from './Auxillary/i18nDebug';
import { I18nDevPanel } from './Components/I18nDevTools';
import ShellLoadingScreen from './Components/ShellLoadingScreen';
import i18n, { initI18n } from './i18n';

interface FeatureFlags {
	enableLanguageConfiguration?: boolean;
}

const initialize = async () => {
	const anonContext = { kind: 'user', key: 'anonymous-id', anonymous: true };

	const FeatureFlagProvider = await InitializeFeatureFlags({
		app: App,
		clientId: Env(Constants.FEATURE_FLAGS_KEY) ?? '',
		options: {
			bootstrap: 'localStorage',
			baseUrl: Env(Constants.FEATURE_FLAGS_URL),
			streamUrl: Env(Constants.FEATURE_FLAGS_URL),
			eventsUrl: Env(Constants.FEATURE_FLAGS_URL),
			diagnosticOptOut: false,
		},
		context: anonContext,
		maxRetries: 5,
	});

	// Read the enableLanguageConfiguration flag from LaunchDarkly before
	// initialising i18n so the shell can lock itself to en-US when the flag
	// is off. LD is already bootstrapped above, so this resolves against the
	// cached/streamed flag values (or {} if LD is unavailable).
	const flags = (await getFeatureFlags()) as FeatureFlags;
	const enableLanguageConfiguration =
		flags?.enableLanguageConfiguration ?? false;

	i18nDebugLog(
		'enableLanguageConfiguration flag from LD:',
		enableLanguageConfiguration,
	);

	await initI18n({ enableLanguageConfiguration });
	i18nDebugLog('i18n ready, proceeding with app initialization');

	ReactDOM.render(
		<I18nextProvider i18n={i18n}>
			<Suspense fallback={<ShellLoadingScreen />}>
				<FeatureFlagProvider />
			</Suspense>
			<I18nDevPanel />
		</I18nextProvider>,
		document.getElementById('app'),
	);
};

initialize();
